import { render, staticRenderFns } from "./TiEditor.vue?vue&type=template&id=00a66ed6&"
import script from "./TiEditor.vue?vue&type=script&lang=js&"
export * from "./TiEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports